import { Identifiable, Resource } from "@planzone/dto";
import { Filter } from "@planzone/dto";

function isFilteredByTags(
  { tags }: Identifiable<Resource>,
  { resourceTags }: Filter,
): boolean {
  return (
    !!resourceTags &&
    resourceTags.length > 0 &&
    !resourceTags.find(
      (tag) =>
        tags.length > 0 &&
        tags.find((t) => (t.name || t) === (tag.name || tag)),
    )
  );
}

export { isFilteredByTags };
